import { create } from 'zustand';
import type { EvidenceToolId } from '@/features/speak2me/components/EvidenceToolRegistry';

export interface EvidenceCaptureRequest {
  sessionId: string;
  defaultMode: 'recording' | 'photo' | 'video';
  linkContentId?: number;
  linkTitle?: string;
}

interface EvidenceToolState {
  activeToolId: EvidenceToolId;
  captureRequest: EvidenceCaptureRequest | null;
  activateTool: (id: EvidenceToolId) => void;
  openCapture: (request: EvidenceCaptureRequest) => void;
  reset: () => void;
}

// Which evidence tool holds the slot. This is a store rather than frame state because
// Neo switches it from the panel two levels above the frame, the same way capture
// submissions already reach the panel through useCaptureFlowStore.
export const useEvidenceToolStore = create<EvidenceToolState>((set, get) => ({
  activeToolId: 'chat',
  captureRequest: null,

  // Switching to capture without Neo having asked still needs a session to key the
  // staged tray and the observation, so one is minted on the spot.
  activateTool: (id) => {
    if (id !== 'observation') {
      set({ activeToolId: id });
      return;
    }
    const existing = get().captureRequest;
    set({
      activeToolId: 'observation',
      captureRequest: existing ?? {
        sessionId: `cap-session-${crypto.randomUUID()}`,
        defaultMode: 'recording',
      },
    });
  },

  openCapture: (request) => set({ activeToolId: 'observation', captureRequest: request }),

  reset: () => set({ activeToolId: 'chat', captureRequest: null }),
}));
